import { render, staticRenderFns } from "./NovoEmolumento.vue?vue&type=template&id=d8e483b6&scoped=true&"
import script from "./NovoEmolumento.vue?vue&type=script&lang=js&"
export * from "./NovoEmolumento.vue?vue&type=script&lang=js&"
import style0 from "./NovoEmolumento.vue?vue&type=style&index=0&id=d8e483b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e483b6",
  null
  
)

export default component.exports